/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandResource } from '@alfa-client/command-shared';
import { StateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HistorieListResourceService } from '../historie-list-resource.service';
import { HistorieListResource } from './historie.model';

@Injectable()
export class HistorieService {
  private readonly listService: HistorieListResourceService = inject(HistorieListResourceService);
  private readonly userProfileService: UserProfileService = inject(UserProfileService);

  public getList(): Observable<StateResource<HistorieListResource>> {
    return this.listService.getList();
  }

  public clearList(): void {
    this.listService.clearList();
  }

  public getAssignedTo(command: CommandResource): Observable<StateResource<UserProfileResource>> {
    return this.userProfileService.getAssignedUserProfile(command, 'assignedTo');
  }
}
